import Swiper from 'swiper';
import { add_swiper_class } from '@corbieres/js/tools/swiper';

export default class Slider {
    
    constructor()
    {
        Slider.hero();
        Slider.related_posts();
        Slider.hero_post();
        if ( window.matchMedia( "(max-width: 1000px)" ).matches ) {
            Slider.hero_agenda();
        }
    }

    static hero() {

        const $hero_slider = $('[data-id="wpiris-hero-slider"]');

        if ($hero_slider.length > 0) {

            $hero_slider.each(function () {

                let $slider = $(this),
                    $slider_wrapper = $(this).find('[data-id="wpiris-hero-slider-wrapper"]'),
                    $slider_item = $(this).find('[data-id="wpiris-hero-slider-item"]'),
                    $class_thumbs = $(this).parents('.banner').find( $('.hero-slider-pagination') );

                add_swiper_class($slider, $slider_wrapper, $slider_item);

                if ( $class_thumbs.length > 0 ) {

                    var hero_slider_pagination = new Swiper($class_thumbs, {
                        slidesPerView: 'auto',
                        touchRatio: 0,
                        allowTouchMove: false,
                    });
                } else {
                    hero_slider_pagination = '';
                }

                new Swiper($slider, {
                    mousewheel: {
                        forceToAxis: true,
                    },
                    autoplay: {},
                    speed: 600,
                    slidesPerView: 1,
                    loop: true,
                    lazy: true,
                    pagination: {
                        el: '[data-id="wpiris-banner-info-pagination"]',
                        type: 'fraction',
                    },
                    navigation: {
                        nextEl: '[data-id="wpiris-banner-info-arrow"]',
                    },
                    thumbs: {
                        swiper: hero_slider_pagination,
                    },
                });

            });
        }
    }


    static related_posts()
    {
        let slider         = '[data-id="wpiris-relatedpost"]',
            slider_wrapper = '[data-id="wpiris-relatedpost-wrapper"]',
            slider_item    = '[data-id="wpiris-relatedpost-item"]';
        
        if ( $( slider ).length > 0 ) {
            
            $( slider ).each( function () {
                
                let slider_elements = $( this ).find( slider_item );
                
                if ( $( slider_elements ).length > 3 || (window.matchMedia( "(max-width: 1000px)" ).matches && $( slider_elements ).length > 2) ||  (window.matchMedia( "(max-width: 650px)" ).matches && $( slider_elements ).length > 1) ) {
                    
                    add_swiper_class( $( this ), $( this ).find( slider_wrapper ), $( this ).find( slider_item ) );
                    
                    let swiper_related_post = new Swiper( $( this ), {
                        mousewheel: {
                            forceToAxis: true,
                        },
                        keyboard: true,
                        spaceBetween: 20,
                        speed: 600,
                        loop: true,
                        watchSlidesVisibility: true,
                        lazy: {
                            threshold: 50,
                            loadPrevNext: true,
                            loadPrevNextAmount: 2,
                        },
                        slidesPerView: 1,
                        pagination: {
                            el: '[data-id="wpiris-banner-info-pagination"]',
                            type: 'fraction',
                        },
                        navigation: {
                            nextEl: '[data-id="wpiris-banner-info-arrow"]',
                        },
                        breakpoints: {
                            650: {
                                slidesPerView: 2,
                                spaceBetween: 20
                            },
                            1000: {
                                slidesPerView: 3,
                                spaceBetween: 20
                            },
                            1300: {
                                slidesPerView: 3,
                                spaceBetween: 40
                            }
                        }
                    } );
                }
            } );
        }
    }
    
    static hero_post()
    {
        let slider         = '[data-id="wpiris-post"]',
            slider_wrapper = '[data-id="wpiris-post-wrapper"]',
            slider_item    = '[data-id="wpiris-post-item"]';
        
        if ( $( slider ).length > 0 ) {
            
            $( slider ).each( function () {
                
                let slider_elements = $( this ).find( slider_item );
                
                if ( $( slider_elements ).length > 1 ) {
                    
                    add_swiper_class( $( this ), $( this ).find( slider_wrapper ), $( this ).find( slider_item ) );
                    
                    let swiper_post = new Swiper( $( this ), {
                        mousewheel: {
                            forceToAxis: true,
                        },
                        keyboard: true,
                        spaceBetween: 20,
                        speed: 600,
                        loop: true,
                        lazy: true,
                        autoHeight: true,
                        slidesPerView: 1,
                        pagination: {
                            el: '[data-id="wpiris-banner-info-pagination"]',
                            type: 'fraction',
                        },
                        navigation: {
                            nextEl: '[data-id="wpiris-banner-info-arrow"]',
                        },
                        breakpoints: {
                            370: {
                                spaceBetween: 20
                            },
                            650: {
                                spaceBetween: 20,
                                slidesPerView: 2,
                            },
                            1000: {
                                spaceBetween: 40,
                                autoHeight: false,
                            }
                        }
                    } );
                }
            } );
        }
    }
    
    static hero_agenda()
    {
        let slider         = '[data-id="wpiris-agenda"]',
            slider_wrapper = '[data-id="wpiris-agenda-wrapper"]',
            slider_item    = '[data-id="wpiris-relatedpost-item"]';
        
        if ( $( slider ).length > 0 ) {
            
            $( slider ).each( function () {
                
                let slider_elements = $( this ).find( slider_item );
                
                if ( $( slider_elements ).length > 1 ) {
                    
                    add_swiper_class( $( this ), $( this ).find( slider_wrapper ), $( this ).find( slider_item ) );
                    
                    let swiper_post = new Swiper( $( this ), {
                        mousewheel: {
                            forceToAxis: true,
                        },
                        keyboard: true,
                        spaceBetween: 20,
                        speed: 600,
                        loop: true,
                        lazy: true,
                        slidesPerView: 1,
                        pagination: {
                            el: '[data-id="wpiris-banner-info-pagination"]',
                            type: 'fraction',
                        },
                        navigation: {
                            nextEl: '[data-id="wpiris-banner-info-arrow"]',
                        },
                        breakpoints: {
                            370: {
                                spaceBetween: 20
                            },
                            650: {
                                spaceBetween: 20,
                                slidesPerView: 2,
                            },
                            1000: {
                                spaceBetween: 40,
                                autoHeight: false,
                            }
                        }
                    } );
                }
            } );
        }
    }
}
